/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export enum KeyCodes {
  ArrowLeft = 'ArrowLeft',
  ArrowUp = 'ArrowUp',
  ArrowRight = 'ArrowRight',
  ArrowDown = 'ArrowDown',
  Backspace = 'Backspace',
  Tab = 'Tab',
  Enter = 'Enter',
  Escape = 'Escape',
  Space = 'Space',
  Spacebar = ' ',
  Home = 'Home',
  End = 'End',
}

export enum IEKeyCodes {
  ArrowUp = 'Up',
  ArrowDown = 'Down',
  ArrowRight = 'Right',
  ArrowLeft = 'Left',
  Space = 'Spacebar',
  Escape = 'Esc',
  Home = 'Home',
  End = 'End',
  Enter = 'Enter',
  Tab = 'Tab',
}
